// extracted by mini-css-extract-plugin
module.exports = {"projects":"style_projects__9V9oR","noProjects":"style_noProjects__329d0"};